import React from "react";

const PageBanner = ({ title, subtitle }) => {
	return (
		<section aria-label="Header Berita" className="relative h-auto w-full bg-gradient-to-br from-green-800 via-green-700 to-green-600">
			<div className="relative z-10 flex items-center justify-center px-4 py-16 md:py-24">
				<div className="text-center">
					<h1 className="text-3xl font-bold text-white md:text-4xl drop-shadow-md">
						{title}
					</h1>
					{subtitle && (
						<p className="mt-2 text-sm text-green-100 md:text-base">
							{subtitle}
						</p>
					)}
				</div>
			</div>
		</section>
	);
};

export default PageBanner;
